// extracted by mini-css-extract-plugin
export default {"Title":"_Title--L362S","ActionsContainer":"_ActionsContainer--t2Mgo","LabelModal":"_LabelModal--CSsDj","SeverityTrigger":"_SeverityTrigger--cgv08"};